import React, { useState, useEffect, useRef } from 'react';

import { FixedSizeList as List } from 'react-window';

import { TV_SHOW_PAGE_CONSTANTS } from '../../../utils/constants/TvShowDetailsPageConstants';
import { MainContainer, SpanTag } from '../DropDown/DropDownStyle';

const DropDownModal = (props: {
  isContactUs: boolean;
  intervalData: string[];
  handleOptionClick: (item: string, index: number) => void;
  positionDownwards: boolean;
  selectedDropDownIndex?: number;
}) => {
  const {
    isContactUs = false,
    intervalData,
    handleOptionClick,
    positionDownwards,
    selectedDropDownIndex
  } = props;
  const [selectedItem, setSelectedItem] = useState<number>(
    selectedDropDownIndex || 0
  );
  const [listWidth, setListWidth] = useState<number>(212);
  const targetRef = useRef(null);
  const handleResize = (entries: ResizeObserverEntry[]) => {
    const newWidth =
      entries && entries.length && entries[0]?.contentRect?.width;
    setListWidth(newWidth);
  };

  useEffect(() => {
    if (typeof window.ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(handleResize);
      if (targetRef?.current) {
        resizeObserver.observe(targetRef?.current);
      }
      return () => {
        if (targetRef?.current) {
          resizeObserver.unobserve(targetRef?.current);
        }
      };
    }
  }, [targetRef]);

  const handleClickHandler = (event: React.MouseEvent<HTMLSpanElement>) => {
    const spanElement = event.target as HTMLSpanElement;
    const clickData = spanElement.dataset.customInfo;
    if (clickData?.length) {
      const ans: string[] = clickData?.split(',');
      setSelectedItem(parseInt(ans[1]));
      handleOptionClick(ans[0], parseInt(ans[1]));
    }
  };

  const Row = ({
    index,
    style
  }: {
    index: number;
    style: React.CSSProperties;
  }) => (
    <SpanTag
      data-testid={`dropDownModalSpan-${index}`}
      data-custom-info={[intervalData[index], index]}
      onClick={handleClickHandler}
      isSelected={index === selectedItem}
      style={style}
      key={index}
      isContactUs={isContactUs}>
      {intervalData[index]}
    </SpanTag>
  );

  const InterValDataList = () => {
    return (
      <>
        {intervalData?.map((item: string, index: number) => {
          return (
            <SpanTag
              data-testid={`dropDownModalSpan-${index}`}
              data-custom-info={[item, index]}
              onClick={handleClickHandler}
              isSelected={index === selectedItem}
              key={index}
              isContactUs={isContactUs}>
              {item}
            </SpanTag>
          );
        })}
      </>
    );
  };

  return (
    <>
      <MainContainer
        isContactUs={isContactUs}
        data-testid="mainDropModalContainer"
        ref={targetRef}
        positionDownwards={positionDownwards}
        isWindowingApplied={intervalData.length > 5}>
        {intervalData.length > 5 ? (
          <List
            height={TV_SHOW_PAGE_CONSTANTS.LIST_HEIGHT}
            itemCount={intervalData.length}
            itemSize={TV_SHOW_PAGE_CONSTANTS.ITEM_SIZE as number} // Adjust this value to the desired height of each item
            width={listWidth}>
            {Row}
          </List>
        ) : (
          <InterValDataList />
        )}
      </MainContainer>
    </>
  );
};

export default DropDownModal;
